export enum DisclaimerModalActionsEnum {
  Decline = 'Decline',
  Close = 'Close',
  Accept = 'Accept',
  Back = 'Back',
}
